import { useState } from 'react'
import {
	BrandNameColorIcon,
	ColorPickerIcon,
	CrossIcon,
	DragAndDropCloudIcon,
	ImportantSignIcon,
	PlusIcon,
	UploadImageIcon,
	WebCrawlerSearchIcon,
} from '../icons'

//color picker
import { SketchPicker } from 'react-color'

//tippyjs
import Tippy from '@tippyjs/react'

export const BrandSetup: React.FC = () => {
	const [firstColor, setFirstColor] = useState<string>('#FF8A65')
	const [secondColor, setSecondColor] = useState<string>('#834431')
	const [thirdColor, setThirdColor] = useState<string>('#FF8A65')

	const [photo, setPhoto] = useState({
		imgURL: '',
	})

	const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		console.log(e.currentTarget.files)
		const file = e.currentTarget.files && e.currentTarget.files[0]
		const photoNewObj = Object.assign(file, {
			imgURL: URL.createObjectURL(file),
		})
		setPhoto(photoNewObj)
	}

	return (
		<div className='brand-setup'>
			<h1>Brand Setup</h1>
			<p>
				To generate ad creatives, you must have a brand, so let’s setup it up.
			</p>

			<section className='cards-grid'>
				<section className='web-crawler-ai'>
					<WebCrawlerSearchIcon />
					<section className='content'>
						<div className='heading'>
							<h3>Website Crawler</h3> <ImportantSignIcon />
						</div>
						<p>
							Give our A.I. your website link and it will try to bring your
							logo, brand colors and name.
						</p>
						<section className='search'>
							<input type='text' placeholder='www.adcreative.ai' />
							<button>Read Website</button>
						</section>
					</section>
				</section>

				<section className='logo-upload'>
					<UploadImageIcon />
					<section className='content'>
						<div className='heading'>
							<h3>Logo Upload</h3> <ImportantSignIcon />
						</div>
						<p>
							You can upload your logo using this area. If you don’t have your
							logo, you can skip this step.
						</p>
						<section>
							{photo.imgURL ? (
								<div className='upload-image-section'>
									<img src={photo.imgURL} alt='imag' />
									<CrossIcon onClick={() => setPhoto({ imgURL: '' })} />
								</div>
							) : (
								<label className='upload-image-section' htmlFor='upload-photo'>
									<p>Click Here to Upload Logo!</p>
									<DragAndDropCloudIcon />
								</label>
							)}
							<input
								type='file'
								accept='image/*'
								onChange={onChangeHandler}
								id='upload-photo'
							/>
						</section>
					</section>
				</section>

				<section className='color-picker'>
					<ColorPickerIcon />
					<section className='content'>
						<h3>Color Select</h3>
						<section className='colors-grid'>
							<Tippy
								interactive={true}
								placement={'bottom'}
								content={
									<SketchPicker
										color={firstColor}
										onChangeComplete={updatedColor =>
											setFirstColor(updatedColor.hex)
										}
									/>
								}>
								<div className='color-card'>
									{firstColor}{' '}
									<div style={{ backgroundColor: firstColor }}></div>
								</div>
							</Tippy>
							<Tippy
								interactive={true}
								placement={'bottom'}
								content={
									<SketchPicker
										color={secondColor}
										onChangeComplete={updatedColor =>
											setSecondColor(updatedColor.hex)
										}
									/>
								}>
								<div className='color-card'>
									{secondColor}{' '}
									<div style={{ backgroundColor: secondColor }}></div>
								</div>
							</Tippy>
							<Tippy
								interactive={true}
								placement={'bottom'}
								content={
									<SketchPicker
										color={thirdColor}
										onChangeComplete={updatedColor =>
											setThirdColor(updatedColor.hex)
										}
									/>
								}>
								<div className='color-card'>
									{thirdColor}{' '}
									<div style={{ backgroundColor: thirdColor }}></div>
								</div>
							</Tippy>
						</section>
					</section>
				</section>

				<section className='brand-name'>
					<BrandNameColorIcon />
					<section className='content'>
						<h3>Brand Name</h3>
						<input type='text' placeholder='AdCreative.ai' />
					</section>
				</section>
			</section>

			<section className='button-section'>
				<button>
					<div>
						<PlusIcon />
					</div>
					Create Brand & Start a Project
				</button>
			</section>
		</div>
	)
}
